import { useState, useEffect } from 'react'
import { Image as ArcoImage } from '@arco-design/web-react'
import Image, { ImageProps } from 'next/image'
import { isBlurValue } from '@/utils/is'
import IconProduct from '@/assets/shop2x.png'
import { isSSR } from '@/utils/is'
import { useMount } from 'ahooks'

interface EchoNextImageProps extends ImageProps {
  errorSrc?: string
  preview?: boolean
  handleError?: () => void
}

const EchoNextImageClient = ({ errorSrc, src, preview, style = {}, handleError, ...rest }: EchoNextImageProps) => {
  const [imgSrc, setImgSrc] = useState(src)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (typeof src === 'string' && src.includes('.heic') && !isSSR) {
      // 兼容.heic图片的显示
      import('heic2any').then(({ default: heic2any }) => {
        try {
          fetch(src)
            .then((res) => res.blob())
            .then((blob) => heic2any({ blob }))
            .then((conversionResult) => {
              const url = URL.createObjectURL(conversionResult as Blob)
              setImgSrc(url)
            })
            .catch((e) => {
              console.log('load image src error:', e)
              setImgSrc(errorSrc || IconProduct.src)
            })
        } catch (error) {
          console.log('fetch error', error)
        }
      })
    } else {
      setImgSrc(src)
    }
  }, [errorSrc, src])

  if (isBlurValue(src)) {
    return null
  }

  return (
    <>
      <Image
        {...rest}
        src={imgSrc}
        style={Object.assign(style, preview ? { cursor: 'zoom-in' } : {})}
        onLoadingComplete={(result) => {
          if (result.naturalWidth === 0) {
            errorSrc && setImgSrc(errorSrc)
          }
        }}
        onError={() => {
          handleError?.()
          errorSrc && setImgSrc(errorSrc)
        }}
        onClick={
          preview
            ? (e) => {
                e.stopPropagation()
                e.preventDefault()
                setVisible(true)
              }
            : undefined
        }
      />
      {preview ? <ArcoImage.Preview src={imgSrc as string} visible={visible} onVisibleChange={setVisible} /> : null}
    </>
  )
}

export default EchoNextImageClient
